import React from "react";
import "./SelectorPlots.css"


function SelectorPlots({passData, setloading1 , setloading2 , setloading3, setloading4 , setloading5 , setloading6, setloading7 , setloading8 , setloading9 , setloading10 , setloading11}) {

    const onTrigger = (event) => {
        passData(event.target.value)
        // setloading1(true)
        // setloading2(true)
        // setloading3(true)
        // setloading4(true)
        // setloading5(true)
        // setloading6(true)
        // setloading7(true)
        // setloading8(true)
        // setloading9(true)
        // setloading10(true)
        // setloading11(true)
    }

    return(
        <div id = "test">
            <p id = "selector-text">Σύγκρινε το έτος επιλογής με τον προηγούμενο</p>
            <select className="form-select" id = "Selector-pos" aria-label=".form-select-lg example" onChange={onTrigger}>
                <option defaultValue ={2017}>Επιλέξτε έτος</option>
                <option value="2017">2017</option>
                <option value="2016">2016</option>
                <option value="2015">2015</option>
                <option value="2014">2014</option>
                <option value="2013">2013</option>
                <option value="2012">2012</option>
                <option value="2011">2011</option>
                <option value="2010">2010</option>
            </select>
        </div>
      

    );
}

export default SelectorPlots;